export default "__VITE_ASSET__D1ERs_RB__"